export * from './duplicata-receber-browse.component';
export * from './duplicata-receber-edit.component';